import React from "react";
import { useTranslation, Trans } from "react-i18next";

export const FatalError = () => {
  const { t } = useTranslation();

  return (
    <div className="flex h-full items-center justify-center py-12">
      <div className="text-center">
        <h2 className="mb-3 text-2xl font-medium text-foreground">
          {t("global.fatalError.title")}
        </h2>
        <p className="text-sm text-muted-foreground">
          <Trans
            i18nKey="global.fatalError.message"
            components={{
              supportLink: (
                <a
                  href="mailto:support@zeemee.com"
                  className="font-medium text-foreground underline hover:no-underline"
                />
              ),
            }}
          />
        </p>
      </div>
    </div>
  );
};
